export const HOME_NAMESPACE = "home";
